<script lang="ts" setup>
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
import { useContent } from '@/domains/investor/composables/useContent'
import Content from '@/domains/investor/components/Content/Content.vue'
import DataView from '@/domains/investor/components/DataView/DataView.vue'
import { useSignificantTransactionsDataView } from '@/domains/investor/significant-transactions/composables/useSignificantTransactionsDataView'

definePageMeta({
  layout: 'investor',
})

const { t, locale } = useI18n()

useHead(() => ({
  title: t('pageTitles.investorSignificantTransactions.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorSignificantTransactions.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorSignificantTransactions.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorSignificantTransactions.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorSignificantTransactions.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorSignificantTransactions.canonical.pl'),
    },
  ],
}))

const { getContent } = await useContent()
const significantTransactionsContent = await getContent('istotne-transakcje')

const {
  page,
  itemsPerPage,
  significantTransactions,
  significantTransactionsColumns,
  total,
  isLoading,
  headerConfig,
} = await useSignificantTransactionsDataView()

</script>

<template>
  <div>
    <InvestorHero
      :title="$t('investor.significantTransactions.hero.title')"
      :lead="$t('investor.significantTransactions.hero.lead')"
      image="/images/investor/hero/significant-transactions.png"
      :first-button="{
        text: $t('investor.significantTransactions.hero.firstButton.label'),
        to: $t('investor.significantTransactions.hero.firstButton.to'),
      }"
    />

    <UiSection
      :id="$t('investor.significantTransactions.sectionId')"
      class="chartered-auditor__section"
      color="white"
    >
   
      <Content :content="significantTransactionsContent.data.value?.content" />
      
      <DataView
        v-model:page="page"
        :table-items="significantTransactions"
        :table-columns="significantTransactionsColumns"
        :total="total"
        :header="headerConfig"
        :items-per-page="itemsPerPage"
        :show-pagination="true"
        :is-loading="isLoading"
        :empty-state-message="$t('common.dataView.empty')"
        :section-id="$t('investor.significantTransactions.dataView.id')"
      />
    </UiSection>
  </div>
</template>

<style scoped lang="scss">
  .chartered-auditor__section {
    padding-top: 0;
  }

  :deep(.dataView__section) {
    @include atXL {
      padding-top: 6.4rem;
    }
  }
</style>
